import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../../shared/services/user.service';
import { GETImplementWarrantyVM, WarrantyTypeVM } from '../../customer-contact/Models/customer-contact.model';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../../GET_NEW_UI/adapters/ordinal-date-adapter';
import { EquipmentSMUHistoryVM, ImplementForEquipmentDetails } from '../../GET_NEW_UI/equipment-details/equipment-details.model';
import { EquipmentDetailsService } from '../../GET_NEW_UI/equipment-details/equipment-details.service';
import { DocumentLibraryService } from '../../GET_NEW_UI/services/document-library.service';
import { EquipmentDetailsParams } from '../../GET_NEW_UI/setup-equipment/setup-equipment.model';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warranty-status-dialog',
  templateUrl: './warranty-status-dialog.component.html',
  styleUrls: ['./warranty-status-dialog.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class WarrantyStatusDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<WarrantyStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _service: DocumentLibraryService,private _user:UserService,
    private _notify: NotificationsService,
    private _equipment: EquipmentDetailsService,  ) { }

    isAdmin:boolean=false
    showIsAdminWarrantyInfo:boolean=false
    equipmentDetails: EquipmentDetailsParams;
    ImplementId:number
    warrantyList: WarrantyTypeVM[] = [];
    startDate: Date = new Date();
    startSmu:number=0
    startCycle:number=0
    WarrantyType:number=0
    warrantyTypeName:string
    status:string
    meterReading:number=0
    WarrantyTypeIntialHours:number=0
    WarrantyTypeIntialDays:number=0
    WarrantyTypeResidualDays:number=0
    ResidualWarrantyHours:number=0
    ImplementWarrantyinfo:GETImplementWarrantyVM
    numberofOriginalWarrantyDays:number=0
    currenddate=new Date()
    ord: OrdinalDateParse = new OrdinalDateParse();
    currentDate: Date = new Date();
   // maxDate: Date = new Date();

   showUpdateButton:boolean=false
   showImplementStatusModal:boolean=false
   currentCMU:number=0
   originalCMU:number=0
   equipmentId:number
   startCMU:number=0;
   SMUHistory: EquipmentSMUHistoryVM[];
  ngOnInit() {

    this.equipmentDetails= this.data.equipmentDetails;
    this.meterReading = this.data.SMU;
    this.ImplementId = this.data.ImplementId;
    
    this.originalCMU=this.data.CMU
    this.equipmentId=this.data.equipmentId
    this.showImplementStatusModal=this.data.showImplementStatusModal
    this.LoadAllWarranties();
    this. LoadJobRoles()
    this.GetWarrantyTypesforImplement();
    
   
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  showWarrantySetup(){
    this.showIsAdminWarrantyInfo=!this.showIsAdminWarrantyInfo
  }

  LoadAllWarranties() {
    this._service.LoadAllWarantyList().subscribe(res => {
      this.warrantyList = res;
    })
  }

  GetWarrantyTypesforImplement()
  {
    
    this._service.GetWarrantyTypesforImplement(this.ImplementId).subscribe(res=>{
      if(res.ID!=0){
        this.showUpdateButton=true
        this.ImplementWarrantyinfo=res
          this.WarrantyType=res.WarrantyId;
          this.warrantyTypeName=res.warrantyTypeName
          this.startDate=res.startDate;
          this.startSmu=res.startSMU
          this.startCycle=res.startCucleNO
          if(res.isExpired==true)
          this.status="Expired"
          if(res.isExpired==false)
          this.status="Valid"
         this.WarrantyTypeIntialHours=res.WarrantyTypeIntialHours
         let currentDate = new Date();
         let  startDate_ = new Date(this.startDate);
          this.startCMU = res.BucketCMU;
         this.numberofOriginalWarrantyDays= Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(startDate_.getFullYear(), startDate_.getMonth(), startDate_.getDate()) ) /(1000 * 60 * 60 * 24));
       //  this.ResidualWarrantyHours=this.WarrantyTypeIntialHours-(this.meterReading-this.startSmu)
         this.WarrantyTypeResidualDays=res.WarrantyTypeIntialDays-this.numberofOriginalWarrantyDays
         this.ResidualWarrantyHours= (res.WarrantyTypeIntialHours -this.originalCMU) + this.startCMU ;//(this.startSmu + res.WarrantyTypeIntialHours) - this.meterReading;  //res.WarrantyTypeIntialHours-this.meterReading
         this.WarrantyTypeIntialDays=res.WarrantyTypeIntialDays
         this.currentCMU= this.originalCMU;//this.originalCMU+ this.WarrantyTypeIntialHours
          


      }
      else this.numberofOriginalWarrantyDays=0
    

    })
  }

  
  LoadJobRoles(){
    this._user.getUserJobRoles().subscribe(roles=>{
      console.log("roles",roles)
        roles.forEach(r => {
            switch (r.Name) {
                case 'Administrator':
                    this.isAdmin=true;
                    break;
                case 'Customer Admin':
                    this.isAdmin = true;
                    break;
            }
        });
      
    })
  }

    Update(){

      if(this.WarrantyType==0 || this.WarrantyType==null){
        this._notify.error('Please Enter Warranty Type')
      }
      else if(this.startDate==null){
        this._notify.error('Please Enter Warranty Start Date')
      }
      else if(this.startSmu==0 && this.showImplementStatusModal==false ){
        this._notify.error('Please Enter Warranty Start SMU')
      }
      else{
        let model= new GETImplementWarrantyVM()
        model.WarrantyId=this.WarrantyType;
        model.startDate= new Date(this.startDate);
        model.startSMU=this.startSmu;
        model.modifiesDate= new Date();
        model.startCucleNO=this.startCycle;
        this._service.UpdateWarrntyImplementLevel(model, this.ImplementId, this.equipmentId).subscribe(res=>{
          if(res==true){
            
           this._notify.success('Successfully Saved');
           this.GetWarrantyTypesforImplement();
          }
          if(res==false){
            this._notify.error('Invalid Start Date and SMU')
          }
          })
      }

    }

    UpdateWithDefault(){
      this._service.LoadImplmentAttchedToEquipmentInfo(this.ImplementId).subscribe(res=>{
        this.startDate = new Date(res.m_Item1);
        this.startSmu = res.m_Item2;
        this.originalCMU = res.m_Item3;
      });
      
      // if(this.WarrantyType==0 || this.WarrantyType==null){
      //   this._notify.error('Please Enter Warranty Type')
      // }
      // else if(this.startDate==null){
      //   this._notify.error('Please Enter Warranty Start Date')
      // }
      // else if(this.startSmu==0 && this.showImplementStatusModal==false ){
      //   this._notify.error('Please Enter Warranty Start SMU')
      // }

     
     
    }


   
}
